var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "641b292c6c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38 18 L 797 18 L 797 777 L 38 777 Z M 38 18 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dcb872f542"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 491.269531 -118.84375 L 933.957031 323.847656 L 347.980469 909.824219 L -94.710938 467.136719 Z M 491.269531 -118.84375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f33a0f9821"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 125.84375 676.148438 C 15.347656 615.917969 27.03125 467.550781 67.414062 365.324219 C 107.695312 263.363281 184.628906 177.1875 274.292969 115.523438 C 381.386719 41.875 612.855469 -51.886719 697.09375 97.902344 C 670.328125 167.328125 632.257812 226.183594 583.359375 273.542969 C 533.507812 321.816406 487.058594 343.925781 437.882812 367.328125 C 395.820312 387.351562 352.324219 408.050781 303.464844 446.160156 C 230.554688 503.027344 171.03125 580.179688 125.84375 676.148438 Z M 699.589844 540.820312 C 773.496094 433.359375 867.636719 200.667969 715.636719 117.164062 C 687.863281 185.351562 649.265625 243.582031 600.28125 291.015625 C 547.566406 342.074219 499.367188 365.011719 448.335938 389.300781 C 407.457031 408.753906 365.183594 428.875 318.429688 465.34375 C 246.039062 521.804688 187.285156 599.410156 143.179688 696.613281 C 205.878906 799.242188 349.878906 787.171875 449.789062 747.699219 C 551.75 707.417969 637.929688 630.484375 699.589844 540.820312 Z M 699.589844 540.820312 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#641b292c6c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dcb872f542)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f33a0f9821)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#705444",
    d: "M 491.269531 -116.511719 L 931.628906 323.847656 L 347.980469 907.496094 L -92.378906 467.136719 Z M 491.269531 -116.511719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBean);
export default __webpack_public_path__ + "static/media/bean.b1ddb0eeb6d967f9a1fe66350b8f38c8.svg";
export { ForwardRef as ReactComponent };